export function getInTouchForm() {
    const form = $('.get-in-touch form');
    const button = form.find('.button');

    form.find(':checkbox').on('change', function () {
        if ($(this).prop('checked')) {
            button.removeAttr('disabled');
        } else {
            button.attr('disabled', true);
        }
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/getInTouchForm.js